import React, { useState } from "react";
import { Modal, Input, Button, Select, Card, Upload, message } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { amountFormat } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  createDispute,
  CreateDisputes,
  getDisputes,
} from "../../actions/disputes";
import useHandleResponse from "../../config/useHandleResponse";
import { UploadOutlined } from "@ant-design/icons";
const { Option } = Select;

const ReportDisputeModal = ({ visible, onCancel }) => {
  const {
    transaction_date,
    amount,
    merchant_name,
    employee_name,
    employee_email,
    payment_method,
    data,
  } = visible;
  const dispatch = useDispatch();
  const createDis = useSelector((state) => state?.disputes?.create);
  // State to manage the list of uploaded files
  const [fileList, setFileList] = useState([]);

  const formik = useFormik({
    initialValues: {
      reason: "",
      nature: "",
      detailed_reason: "",
    },
    validationSchema: Yup.object({
      reason: Yup.string().required("Please select a dispute reason"),
      nature: Yup.string().required("Please select the nature of the dispute"),
      detailed_reason: Yup.string().required(
        "Please provide a detailed reason"
      ),
    }),
    onSubmit: (values) => {
      const employee_id = sessionStorage.getItem("employee_id");
      const formData = new FormData();
      Object.keys(values).forEach((ele) => {
        formData.append(ele, values[ele]);
      });
      formData.append("transaction_id", visible.id);
      formData.append("amount", visible.amount);
      formData.append("account", visible.card_reference_number);
      formData.append("account_type", "card");
      formData.append("remitter_account", "card");
      formData.append("remitter_name", visible.employee_name);
      formData.append("payment_type", visible.payment_method);
      formData.append("txn_initiated_at", visible.transaction_date);
      formData.append("employee_id", employee_id)

      fileList.forEach((fileValues, index) => {
        formData.append(`files[${index}].file`, fileValues?.originFileObj);
      });
      dispatch(createDispute(formData));
    },
  });

  const formatLabel = (key) => {
    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camel case words
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b[a-z]/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  useHandleResponse(
    CreateDisputes,
    createDis?.data?.message,
    createDis?.data?.message,
    createDis,
    () => {
      onCancel();
    }
  );

  // Handler for when file(s) are uploaded
  const handleOnChange = async ({ fileList: newFileList, file }) => {
    setFileList(newFileList);
  };

  const handleBeforeUpload = (file) => {
    const isValidType =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/gif" ||
      file.type === "application/pdf";

    const isValidSize = file.size / 1024 / 1024 < 5;

    if (!isValidType) {
      message.error(
        <span className="messageText">Please upload pdf, jpg or png file.</span>
      );
      return Upload.LIST_IGNORE;
    }

    if (!isValidSize) {
      message.error("File must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  const reasonForDisputeValues = [
    "Transaction not done by Cardholder",
    "Goods & Services not provided",
    "Goods not as described",
    "Duplicate transaction",
    "Account debited but not received to Merchant",
    "Paid By other means",
    "Fraud",
    "Offline transaction - double debit",
    "Offline transaction - Incorrect amount",
    "Offline transaction - Goods and services not delivered",
    "Offline transaction - Payment by other means"
  ];

  const natureOfDisputeValues = [
    "No authorization, Auth failed but settlement received, Auth reversal but settlement received & credit received against authorization",
    "Goods, services & merchandise not provided",
    "Other goods received against ordered goods",
    "Multiple settlement received against same RRN or ARN",
    "Cardholder account debited but not received at merchant location",
    "Paid through other mode of channel (UPI, Cash, etc.)",
    "Fraud Transaction",
    "Multiple settlement received against same RRN or ARN",
    "Incorrect amount from the original amount",
    "Goods, services & merchandise not provided",
    "Paid through other mode of channel (UPI, Cash, etc.)"
  ];



  return (
    <Modal
      title="Raise a Dispute"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className="right-alinged-modal md"
    >
      {!visible ? null : (
        <>
          <div className="item-details">
            <div className="item-detail">
              <label>Transaction Date</label>
              <p>{transaction_date}</p>
            </div>

            <div className="item-detail">
              <label>Amount</label>
              <p>{`INR ${amountFormat(amount)}`}</p>
            </div>

            <div className="item-detail">
              <label>Merchant</label>
              <p>{merchant_name}</p>
            </div>

            <div className="item-detail">
              <label>Employee</label>
              <p>{`${employee_name} (${employee_email})`}</p>
            </div>

            <div className="item-detail">
              <label>Payment Method</label>
              <p>{payment_method}</p>
            </div>
          </div>
          {/* Dynamically render fields */}
          {/* <h4 className="mt1 mb1">Transaction Fields</h4>
          <div className="item-details">
            {fields.map(
              (field, index) =>
                field.key !== "amount" && (
                  <div className="item-detail" key={index}>
                    <label>{formatLabel(field.key)}</label>
                    <p>{field.value || "N/A"}</p>
                  </div>
                )
            )}
          </div> */}
          {/* Dynamically render data fields */}
          <h4 className="mt1 mb1">Additional Data</h4>
          <div className="item-details">
            {Object.keys(data)
              ?.filter((ele) => ele !== "txnAmount" && ele !== "txnDescription")
              .map((key, index) => (
                <div className="item-detail" key={index}>
                  <label>{formatLabel(key)}</label>
                  <p>{data[key] || "N/A"}</p>
                </div>
              ))}
          </div>
        </>
      )}
      <h3 className="mt2">Dispute Transaction</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="form-group">
          <label className="required">Reason for Dispute</label>
          <Select
            name="reason"
            onChange={(value) => {
              let findIndexValue = reasonForDisputeValues?.indexOf(value);
              formik.setFieldValue("reason", value)
              formik.setFieldValue("nature", natureOfDisputeValues[findIndexValue]);
            }}
            value={formik.values.reason}
            onBlur={formik.handleBlur}
            style={{ width: "100%" }}
          >
            <Option value="Transaction not done by Cardholder">
              Transaction not done by Cardholder
            </Option>
            <Option value="Goods & Services not provided">
              Goods & Services not provided
            </Option>
            <Option value="Goods not as described">
              Goods not as described
            </Option>
            <Option value="Duplicate transaction">Duplicate transaction</Option>
            <Option value="Account debited but not received to Merchant">
              Account debited but not received to Merchant
            </Option>
            <Option value="Paid By other means">Paid By other means</Option>
            <Option value="Fraud">Fraud</Option>
            <Option value="Offline transaction - double debit">
              Offline transaction - double debit
            </Option>
            <Option value="Offline transaction - Incorrect amount">
              Offline transaction - Incorrect amount
            </Option>
            <Option value="Offline transaction - Goods and services not delivered">
              Offline transaction - Goods and services not delivered
            </Option>
            <Option value="Offline transaction - Payment by other means">
              Offline transaction - Payment by other means
            </Option>
          </Select>
          {formik.touched.reason && formik.errors.reason ? (
            <div className="error">{formik.errors.reason}</div>
          ) : null}
        </div>

        <div className="form-group">
          <label className="required">Nature of Dispute</label>
          <Select
            name="nature"
            onChange={(value) => {
              let findIndexValue = natureOfDisputeValues?.indexOf(value);
              formik.setFieldValue("nature", value)
              formik.setFieldValue("reason", reasonForDisputeValues[findIndexValue]);
            }}
            value={formik.values.nature}
            onBlur={formik.handleBlur}
            style={{ width: "100%" }}
          >
            <Option value="No authorization, Auth failed but settlement received, Auth reversal but settlement received & credit received against authorization">
              No authorization, Auth failed but settlement received, Auth
              reversal but settlement received & credit received against
              authorization
            </Option>
            <Option value="Goods, services & merchandise not provided">
              Goods, services & merchandise not provided
            </Option>
            <Option value="Other goods received against ordered goods">
              Other goods received against ordered goods
            </Option>
            <Option value="Multiple settlement received against same RRN or ARN">
              Multiple settlement received against same RRN or ARN
            </Option>
            <Option value="Cardholder account debited but not received at merchant location">
              Cardholder account debited but not received at merchant location
            </Option>
            <Option value="Paid through other mode of channel (UPI, Cash, etc.)">
              Paid through other mode of channel (UPI, Cash, etc.)
            </Option>
            <Option value="Fraud Transaction">Fraud Transaction</Option>
            <Option value="Incorrect amount from the original amount">
              Incorrect amount from the original amount
            </Option>
          </Select>
          {formik.touched.nature && formik.errors.nature ? (
            <div className="error">{formik.errors.nature}</div>
          ) : null}
        </div>

        <div className="form-group">
          <label className="required">Explain the situation</label>
          <Input.TextArea
            name="detailed_reason"
            onChange={formik.handleChange}
            value={formik.values.detailed_reason}
            onBlur={formik.handleBlur}
            placeholder="Detail the reason for your chargeback."
          />
          {formik.touched.detailed_reason && formik.errors.detailed_reason ? (
            <div className="error">{formik.errors.detailed_reason}</div>
          ) : null}
        </div>

        <div className="mb1 dispute-upload">
          <Upload
            multiple
            fileList={fileList}
            onChange={handleOnChange}
            beforeUpload={handleBeforeUpload}
          >
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </div>

        <div className="action-btns">
          <button type="button" onClick={onCancel} className="secondary-btn">
            Cancel
          </button>
          <button disabled={createDis?.loading} className="primary-btn">
            Raise Dispute
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ReportDisputeModal;
